import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./css/light.css";
import "./css/dark.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "material-symbols/outlined.css";
import "@material/web/all.js";
import App from "./App";
import { initializeTheme } from "./utils/theme_utils";
import { initializeServiceWorker } from "./utils/serviceWorker";

// Initialize theme system
initializeTheme();

// Initialize service worker for PWA
if (process.env.NODE_ENV === 'production') {
  initializeServiceWorker();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
